import type { ContextReal } from "../types.real";

/**
 * Con qué arranca «Tono», «Qué ofrecés» y «Por dónde y cuándo» en una campaña nueva.
 *
 * Arrancaba en lo que la misma pantalla desaconseja: horario «Sin restricción» («un mensaje a las 3am
 * molesta…») y frecuencia «Sin límite» («la forma más rápida de quemar la base»), con «1 semana» marcado
 * como recomendado; y con un descuento habitual de 20% contra un techo de 15%, así que el paso se abría
 * con el aviso de que el descuento supera el techo antes de tocar nada. Ahora arranca en lo recomendado:
 * horario comercial (9 a 21, todos los días), una semana entre mensajes a la misma persona y el
 * descuento igual al techo. Todo se puede cambiar en el paso.
 */
export function contextoPorDefecto(): ContextReal {
  return {
    usaDescuentos: true,
    descuento: "15%",
    cuponBienvenida: true,
    canales: "Todos",
    programaPuntos: false,
    tono: "Amigable",
    techoPct: 15,
    franjaHoraria: { desde: "09:00", hasta: "21:00", dias: [] },
    fatigaDias: 7,
  };
}
